const angular = require('angular');
const uiRouter = require('angular-ui-router');
const restangular = require('restangular'); // eslint-disable-line no-unused-vars
const olyDialog = require('oly-dialog');

const wowCommonModule = require('../common/common.module');
const olyCommonModule = require('../olycommon/olycommon.module');

const orderModuleName = 'wowApp.order';

angular.module(orderModuleName, [olyCommonModule, wowCommonModule, uiRouter, 'restangular', olyDialog]);

// ------------------------------------------
// Components
// ------------------------------------------
require('./confirmation');
require('./orderinstructions');
require('./ordermanagement');
require('./packaging');
require('./savedcard');

module.exports = orderModuleName;



// WEBPACK FOOTER //
// ./src/order/order.module.js